<template>
  <v-snackbar :timeout="6000" auto-heigth multi-line v-model="successFull" color="primary" centered>
    <v-layout align-center pr-4>
      <v-icon class="pr-3" dark large>mdi-clipboard-off</v-icon>
      <v-layout column>
        <div>
          <strong>Probleem</strong>
        </div>
        <div>Er gaat iets niet goed, Probeer het nogmaals en neem anders contact met ons op!</div>
      </v-layout>
    </v-layout>
  </v-snackbar>
</template>

<script>

export default {
  name: "invProblem", methods: {},

  data() {
    return {
      successFull: false,
    }
  },
  created () {
    // eslint-disable-next-line no-undef
    EventBus.$on('invProblem', (data) =>{
      this.successFull = data;
    })

  }
}
</script>

<style scoped></style>
